import { supabase } from "../SupabaseClient";

export const fetchUser = async () => {
  try {
    const { data, error } = await supabase.auth.getUser();

    if (error) {
      console.error(
        "Erreur lors de la récupération de l'utilisateur :",
        error.message,
      );
      return null;
    }

    if (!data?.user) {
      console.warn("Aucun utilisateur connecté.");
      return null;
    }

    const userId = data.user.id;

    // Récupérer les rôles de l'utilisateur
    const { data: roles, error: roleError } = await supabase
      .from("user_roles")
      .select("role_id")
      .eq("user_id", userId);

    if (roleError) {
      console.error(
        "Erreur lors de la récupération des rôles :",
        roleError.message,
      );
      return { ...data.user, user_roles: [] }; // Retourne tout de même l'user sans rôle
    }

    return { ...data.user, user_roles: roles || [] };
  } catch (err) {
    console.error("Erreur inattendue :", err);
    return null;
  }
};
